// extracted by mini-css-extract-plugin
module.exports = {"Button":"s_rl p_rl p_q1 g_fl g_fz g_fp g_g9","full":"s_r2 g_dl g_dw","width100":"s_dl g_dl","design3Pos":"s_r3 g_dQ"};